export default {
  namespaced: true,
  state: () => ({
    alertModal: {
      show: false,
      message: '',
      onConfirm: null,
      verticalAlign: 'center',
    },
  }),
  mutations: {
    SET_ALERT_MODAL(state, payload) {
      state.alertModal = { ...payload }
    },
  },
  actions: {
    showAlertModal({ commit, dispatch }, { message, onConfirm, verticalAlign }) {
      const defaultOnConfirm = () => {
        dispatch('hideAlertModal')
      }

      commit('SET_ALERT_MODAL', {
        show: true,
        message,
        onConfirm: onConfirm || defaultOnConfirm,
        verticalAlign: verticalAlign || 'center',
      })
    },
    hideAlertModal({ commit }) {
      commit('SET_ALERT_MODAL', {
        show: false,
        message: '',
        onConfirm: null,
        verticalAlign: 'center',
      })
    },
  },
  getters: {
    alertModal(state) {
      return state.alertModal
    },
  },
}
